<div class="container">
  <mat-card appearance="outlined">
    <mat-card-title class="btn btn-rose">Add New Category</mat-card-title>
    <mat-card-subtitle></mat-card-subtitle>
    <mat-card-content>
      <form [formGroup]="addCategoryForm" (ngSubmit)="addCategoryForm.valid && saveCategory()" novalidate>
        <div class="row">
          <div class="col-12 col-sm-6 col-md-4">
            <mat-form-field color="accent">
              <mat-label>Product</mat-label>
              <mat-select formControlName="productId" [placeholder]="'Products'">
                <mat-option [value]="null">Select an option</mat-option>
                <mat-option *ngFor="let product of productOptions; let i = index;" [value]="product.productId">
                  {{product.productName}}
                </mat-option>
              </mat-select>
              <mat-error *ngIf="addCategoryForm.get('productId').hasError('required')">
                Product is required.
              </mat-error>
              
            </mat-form-field>
          </div>
          <div class="col-12 col-sm-6 col-md-4">
            <mat-form-field color="accent">
              <mat-label>Category Name</mat-label>
              <input matInput type="text" placeholder="categoryName" name="categoryName" id="categoryName"
                formControlName="categoryName" [placeholder]="'Category'" autocomplete="off" appInputValidator
              [sanitizeScriptTags]="true" [hasAtLeastOneAlphabet]="true">
                <mat-error *ngIf="addCategoryForm.get('categoryName').hasError('required')">
                  Category Name is required.
                </mat-error>
                <mat-error *ngIf="addCategoryForm.get('categoryName').hasError('maxlength')">
                  Category Name cannot be more than 50 characters.
                </mat-error>
                <mat-error *ngIf="addCategoryForm.get('categoryName').hasError('noAlphabet')">
                 Must contain at least one alphabet.
            </mat-error>
            </mat-form-field>
          </div>
          <div class="col-12 col-sm-6 col-md-4">
            <mat-form-field color="accent">
              <mat-label>Description</mat-label>
              <input matInput type="text" placeholder="description" name="description" id="description"
                formControlName="description" [placeholder]="'Description'" autocomplete="off" appInputValidator
              [sanitizeScriptTags]="true" [hasAtLeastOneAlphabet]="true">
                <mat-error *ngIf="addCategoryForm.get('description').hasError('required')">
                  Description is required.
                </mat-error>
                <mat-error *ngIf="addCategoryForm.get('description').hasError('maxlength')">
                  Description cannot be more than 100 characters.
                </mat-error>
                  <mat-error *ngIf="addCategoryForm.get('description').hasError('noAlphabet')">
                  Must contain at least one alphabet.
                </mat-error>
            </mat-form-field>
          </div>

        </div>
      </form>
    </mat-card-content>
    <mat-card-footer>
      <div class="row action-btn justify-content-center">
        <div class="col-md-6">
          <button md-raised-button type="button" class="btn btn-round btn-block btn-rose"
            (click)="close()">Close</button>
        </div>
        <div class="col-md-6">
          <button md-raised-button type="button" class="btn btn-round btn-block btn-rose" (click)="saveCategory()"
            [disabled]="!addCategoryForm.valid">Save</button>
        </div>
      </div>
    </mat-card-footer>
  </mat-card>
</div>
